
 class Profile {
    private epid: string;
    private id: string;

    constructor(epid: string, id: string) {
        this.epid = epid;
        this.id = id;
    }

    // don't use setters

    public getEpid(): string {
        return this.epid;
    }

    public getId(): string {
        return this.id;
    }

}

export default Profile;